import { createRouter, type RouterHistory } from '@tanstack/react-router';
import type { CurrentUser } from '@/hook/useCurrentUser';
import { routeTree } from './routeTree.gen';

export interface RouterContext {
  /** The user's row when a guard runs, not a copy from an earlier render.
   * Null when nobody is signed in. */
  account: () => CurrentUser | null;
}

export const createAppRouter = (history: RouterHistory, account: RouterContext['account']) =>
  createRouter({
    routeTree,
    history,
    context: { account },
    // Render errors go to the app's own boundaries in Layout and App.
    disableGlobalCatchBoundary: true,
  });

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
